import React from 'react';
import _ from 'lodash';
import { parseAmount } from 'app/utils/parsers';
import { Card, CardBody } from 'reactstrap';

import SectionGroup from 'app/components/general/SectionGroup';

//

interface ICartSummaryProps {
  lineItems: any;
  totalAmount: number;
}

export default class CartSummary extends React.Component<
ICartSummaryProps,
{}
> {
  static defaultProps: ICartSummaryProps = {
    lineItems: {},
    totalAmount: 0,
  };

  renderLineItems = () => _.map(
    _.sortBy(this.props.lineItems, (item) => item.amount),
    (lineItem) => (
      <div key={lineItem.description}>
        <div className="row with-margin-top-5">
          <div className="col col-8 text-dark-grey d-flex">
            <div>
              <div className="number-label">{lineItem.quantity}</div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              {lineItem.description}
            </div>
          </div>
          <div className="col col-4 text-right text-dark-grey">
            {parseAmount(lineItem.quantity * lineItem.amount)}
          </div>
        </div>
      </div>
    ),
  );

  render(): React.ReactNode {
    return (
      <div className="row with-margin-top">
        <div className="col col-12">
          <SectionGroup title="Cart summary">

            {this.renderLineItems()}
            <div className="row with-margin-top">
              <div className="col text-black text-weight-medium-bold">
                Total Amount
              </div>
              <div className="col text-right text-dark-grey text-weight-medium-bold">
                {parseAmount(this.props.totalAmount)}
              </div>
            </div>
          </SectionGroup>
        </div>
      </div>
    );
  }
}
